import React, { useCallback, useState } from 'react';
import useSort from '../../hooks/useSort';
import MobileModal from '../MobileModal';
export default function Sort({ isOpen: defaultOpen = true, sortOptions: sortOptionsFromProps, children, }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const { sortOptions, selectedSort, changeSelectedSort } = useSort({
        sortOptions: sortOptionsFromProps,
    });
    const toggleCollapsible = () => {
        setIsOpen(!isOpen);
    };
    const isChecked = useCallback((option) => selectedSort?.sortBy === option.sortBy && selectedSort?.sortOrder === option.sortOrder, [selectedSort]);
    const getOptionId = (option, idSuffix = '') => `${option.sortBy}-${option.sortOrder}${idSuffix}`;
    const genDefaultMarkup = useCallback((idSuffix = '') => {
        const handleOptionChange = (event) => {
            changeSelectedSort(JSON.parse(event.target.value));
        };
        return sortOptions.map((option) => (React.createElement("label", { htmlFor: getOptionId(option, idSuffix), key: `${getOptionId(option, idSuffix)}${isChecked(option) ? '-checked' : ''}` },
            React.createElement("input", { id: getOptionId(option, idSuffix), type: 'radio', name: getOptionId(option, idSuffix), value: JSON.stringify(option), checked: isChecked(option), onChange: handleOptionChange }),
            React.createElement("span", null, option.displayName))));
    }, [changeSelectedSort, isChecked, sortOptions]);
    return (React.createElement(React.Fragment, null, typeof children === 'function' ? (children({
        sortOptions,
        selectedSort,
        changeSelectedSort,
    })) : (React.createElement("div", { className: 'cio-plp-sort' },
        React.createElement("button", { type: 'button', className: 'collapsible', onClick: toggleCollapsible },
            selectedSort?.displayName ? (React.createElement("span", { className: 'cio-plp-sort-button-label' },
                React.createElement("span", { className: 'cio-large-screen-only' }, "Sort by:"),
                React.createElement("span", { className: 'cio-mobile-only' }, "By"),
                " ",
                selectedSort.displayName)) : ('Sort'),
            React.createElement("i", { className: `arrow ${isOpen ? 'arrow-up' : 'arrow-down'}` })),
        React.createElement(MobileModal, { side: 'right', isOpen: isOpen, setIsOpen: setIsOpen }, genDefaultMarkup('-mobile')),
        isOpen && (React.createElement("div", { className: 'collapsible-content cio-large-screen-only' }, genDefaultMarkup()))))));
}
Sort.defaultProps = {
    isOpen: true,
};
